import React, { FC } from 'react';
import styled from '@emotion/styled';
import { HotelSearchHit, useButton, useI18n } from '~Hooks';
import { Box, TransparentButton } from '~Styles';
import Paragraph from '~ComponentsImproved/Typography/Paragraph';
import RoomNumber from '../RoomNumber';

/** Same row look as the SearchSelect OptionRow so result lists match across modals. */
const ResultRow = styled(TransparentButton)`
  background-color: var(--colorBlueGray1100);
  border: 1px solid var(--colorBlueGray1100);
  border-radius: 8px;
  padding: 10px 16px;
  text-transform: none;
  text-align: left;
  min-height: 56px;

  &:active {
    background-color: var(--colorBlueGray1100);
  }
`;

interface Props {
  hit: HotelSearchHit;
  onSelect: (hit: HotelSearchHit) => void;
}

/** Own component so each row gets its own useButton. No-post guests are shown but locked. */
const SearchResult: FC<Props> = ({ hit, onSelect }) => {
  const { i18n } = useI18n();
  const button = useButton({ onClick: () => onSelect(hit), disabled: hit.noPost });

  return (
    <ResultRow {...button} fluid justifyContent="space-between">
      <Box display="flex" flexDirection="column" alignItems="flex-start">
        <Paragraph level={2} fontWeight={600} color="var(--colorWhite)">
          {hit.name}
        </Paragraph>
        {hit.noPost && (
          <Paragraph level={4} color="var(--colorUIRed)">
            {i18n('HotelRoom.NoPost')}
          </Paragraph>
        )}
      </Box>
      <RoomNumber target={hit} />
    </ResultRow>
  );
};

export default SearchResult;
